import { useState } from "react";
import { Link } from "react-router-dom";
import client from "../api/client";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await client.post("/auth/forgot-password", { email });
      setSubmitted(true);
    } catch {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <div className="w-full max-w-xl rounded-xl bg-[#1D345F] px-5 py-6 shadow-lg sm:px-8">
        <h1 className="mb-2 text-left text-2xl font-semibold ">Forgot password</h1>

        {submitted ? (
          <div className="mt-4 text-left">
            <p className="text-sm text-white">
              If an account exists for <strong>{email}</strong>, you'll receive a password reset email shortly.
            </p>
            <Link to="/login" className="mt-4 inline-block text-sm text-white underline">
              Back to sign in
            </Link>
          </div>
        ) : (
          <>
            <p className="mb-6 text-left text-sm text-white">
              Enter your email and we'll send you a reset link.
            </p>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="mb-1 block text-sm font-medium text-white">Email</label>
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 text-black bg-white"
                />
              </div>
              {error && <p className="text-sm text-red-600">{error}</p>}
              <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full rounded-lg bg-[#45a164] px-4 py-2 text-sm font-medium text-white hover:border-white border-2 border-[#1D345F] disabled:opacity-50 sm:w-1/2"
                >
                  {loading ? "Sending..." : "Send reset link"}
                </button>
                <p className="text-center text-sm sm:text-right">
                  <Link to="/login" className="text-white hover:underline">Back to sign in</Link>
                </p>
              </div>
            </form>

          </>
        )}
      </div>
    </div>
  );
}
